import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";
import * as resolvType from "../../utils/resolveType.js";

const Ventil = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);
  let resolvedValue = value.value;

  // Bit auflösen
  if (props.element.bit !== undefined) {
    resolvedValue = resolvType.readBit(
      value.value,
      props.element.bit,
      value.type
    );
  }

  //========================================================================
  // Index als Wert aus globalVars
  let idx = Math.abs(parseInt(resolvedValue));

  //========================================================================
  // Simulation
  let simulation = false;
  let simValue = 0;

  try {
    simulation = props.style.properties.simulation;
    simValue = props.style.properties.simValue;
  } catch (error) {
    simulation = false;
  }

  if (simulation) {
    idx = Math.abs(parseInt(simValue));
  }

  //========================================================================
  // Bilder laden
  const pathZu = require("../../images/controls/Ventil/VentilZu.png");
  const pathOffen = require("../../images/controls/Ventil/VentilOffen.png");
  const pathÖffnet = require("../../images/controls/Ventil/VentilÖffnet.gif");
  const pathSchließt = require("../../images/controls/Ventil/VentilSchließt.gif");
  const pathÖffnetNicht = require("../../images/controls/Ventil/VentilÖffnetNicht.gif");
  const pathSchließtNicht = require("../../images/controls/Ventil/VentilSchließtNicht.gif");
  const pathSto = require("../../images/controls/Ventil/VentilSto.gif");

  let imagePath = pathZu;
  if (isFinite(idx)) {
    switch (idx) {
      case 0:
        imagePath = pathZu;
        break;
      case 1:
        imagePath = pathOffen;
        break;
      case 2:
        imagePath = pathÖffnet;
        break;
      case 3:
        imagePath = pathSchließt;
        break;
      case 4:
        imagePath = pathÖffnetNicht;
        break;
      case 5:
        imagePath = pathSchließtNicht;
        break;
      case 6:
        imagePath = pathSto;
        break;
    }
  }

  return (
    <img
      style={{
        ...props.style,
        visibility: props.props.visibility,
      }}
      title={
        language.displayText(value.name) +
        (globalVars.cyclicUpdate || globalVars.editor
          ? "\n" + ("Variable: " + props.props.variable)
          : "")
      }
      src={imagePath}
    />
  );
});

export default Ventil;
